/**
 * @deprecated This module is deprecated.
 * Use the exports from `@kidslabs/module-core` or `./modules/stores` instead.
 *
 * Legend-State IndexedDB Sync Plugin
 *
 * All functionality has been moved to:
 * - packages/modules/module-core/src/modules/stores/store.setup.ts
 *
 * This file re-exports from the new location for backward compatibility.
 */

// Re-export from the main store setup for backward compatibility
export {
    initializeIndexedDBStores as initializeIndexedDBPersistence,
    isIndexedDBReady as isIndexedDBPersistenceInitialized,
    getRegisteredStores as getConfiguredTableNames,
    syncPluginWebStore,
    hydrationState$,
    isStoreHydrated,
    waitForHydration,
} from '../../modules/stores/store.setup';

export type { SyncPluginWebStoreOptions } from '../../modules/stores/store.setup';
